module.exports = __webpack_public_path__ + "img/bg_onepack.28b54321.png";